<template>
  <section>
    <div v-if="respondable">
      <p class="question">{{ model.question.question }}</p>
      <radio-group :options="model.question.options" name="poll" v-model="model.response" @input="save()" />
    </div>
    <div v-else>
      <p class="question">{{ model.question.question }}</p>
      <chart class="quikpoll" :data="data" :labels="labels" />
      <ul class="legend">
        <li v-for="option in options" :color="option.color">
          <span class="color" :style="{backgroundColor: option.color}"></span>
          <span class="label">{{ option.value }}</span>
          <span class="percent">{{ option.percent }}%</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>

  import { Pie } from 'vue-chartjs'

  const colors = ['#0361A8', '#8e6fbc', '#79ac6a', '#808080', '#e5d94f']

  export default {
    name: 'QuikPoll',
    props: {
      model: {
        type: Object,
        required: true
      },
      respondable: {
        type: Boolean
      }
    },
    data () {
      let data = []
      let labels = []
      _.each(this.model.question.options, (option) => {
        data.push(option.votes)
        labels.push(option.value)
      })
      return {
        colors,
        data,
        labels,
        options: (() => {
          return this.model.question.options.map((option, index) => {
            return _.assign(option,{
              color: colors[index],
              percent: (( option.votes / _.sum(data) ) * 100).toFixed(1)
            })
          })
        })()
      }
    },
    methods: {
      save (model) {
        this.model.DSSave()
      }
    },
    components: {
      chart: {
        extends: Pie,
        props: ['data','labels'],
        mounted () {

          this.renderChart({
            datasets: [{
              data: this.data,
              backgroundColor: colors
            }],
            labels: this.labels
          }, {
            tooltips: { enabled: false },
            hover: false,
            legend: false,
            responsive: true
          })
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .question {
    margin-bottom:2rem;
  }

  .quikpoll {
    max-width:60%; max-height:60%; margin:0 auto;
    @include media(xxlarge) {
      max-width:40%; max-height:40%;
    }
  }

  .legend {
    @include list-style-reset;
    margin-top:7rem;
    li {
      display:flex;
    }
    li + li {
      margin-top:2rem;
    }
    .color {
      @include size(3rem);
      flex-shrink: 0; border-radius:50%;
    }
    .label {
      flex:1; margin:0 2rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/quik-poll.vue